import React from 'react';
import Input from '../../../components/ui/Input';

const ProjectBasicInfo = ({ formData, errors, onChange }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-xl font-semibold text-foreground mb-6">Project Information</h2>
      <div className="space-y-6">
        <Input
          label="Project Name"
          type="text"
          name="projectName"
          placeholder="Enter project name (e.g., Downtown Office Renovation)"
          value={formData?.projectName}
          onChange={onChange}
          error={errors?.projectName}
          required
          description="Choose a descriptive name for easy identification"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Estimated Start Date"
            type="date"
            name="estimatedStartDate"
            value={formData?.estimatedStartDate}
            onChange={onChange}
            error={errors?.estimatedStartDate}
            required
            description="When do you plan to begin?"
          />

          <Input
            label="Estimated End Date"
            type="date"
            name="estimatedEndDate"
            value={formData?.estimatedEndDate}
            onChange={onChange}
            error={errors?.estimatedEndDate}
            required
            description="Target completion date"
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectBasicInfo;